import { useState } from 'react';
import { Col, Divider, Form, Input, InputNumber, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import { formItemLayout, selectOptionsTypes } from '../../utils/constants';
import DynamicSelect from '../../components/common/dynamicSelect';
import { rederOrderItemConditionsFields } from '../../utils/functions';

const UpdateOrderItemForm = ({ onFormSave, orderItemData }) => {
    const { t } = useTranslation();
    const [formFieldsSelectedLabels, setFormFieldsSelectedLabels] = useState({});

    const onSelectOptionChange = (type, selectedOption) => {
        const propKey = `${type + 'Label'}`;
        setFormFieldsSelectedLabels(prev => ({ ...prev, [propKey]: selectedOption.label }));
    }

    const onUpdate = (values) => {
        const mergedData = { ...formFieldsSelectedLabels, ...values };
        onFormSave(mergedData);
        console.log("update item", mergedData)
    }

    return (
        <Form
            id="updateOrderItemForm"
            className='orderItemForm'
            layout="vertical"
            size='small'
            {...formItemLayout}
            onFinish={onUpdate}
        >
            <Row gutter={16}>

                <Form.Item name="id" initialValue={orderItemData.id} hidden={true}></Form.Item>

                <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 8 }} lg={{ span: 8 }}>
                    <Form.Item
                        label={t('order.material')}
                        name="material"
                        rules={[{ required: true, message: t('messages.requiredField') }]}
                        initialValue={orderItemData.material}
                    >
                        <DynamicSelect location="update" type={selectOptionsTypes.material} onSelectChange={onSelectOptionChange} />
                    </Form.Item>
                </Col>

                <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 8 }} lg={{ span: 8 }}>
                    <Form.Item
                        label={t('order.orderQuantity')}
                        name="orderQuantity"
                        rules={[{ required: true, message: t('messages.requiredField') }]}
                        initialValue={orderItemData.orderQuantity}
                    >
                        <InputNumber min={0} style={{ width: "100%" }} />
                    </Form.Item>
                </Col>

                <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 8 }} lg={{ span: 8 }}>
                    <Form.Item
                        label={t('order.plant')}
                        name="plant"
                        initialValue={orderItemData.plant}
                    >
                        <DynamicSelect location="update" type={selectOptionsTypes.plant} onSelectChange={onSelectOptionChange} />
                    </Form.Item>
                </Col>

                <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 8 }} lg={{ span: 8 }}>
                    <Form.Item
                        label={t('order.storageLocation')}
                        name="storageLocation"
                        initialValue={orderItemData.storageLocation}
                    >
                        <DynamicSelect location="update" type={selectOptionsTypes.storageLocation} onSelectChange={onSelectOptionChange} />
                    </Form.Item>
                </Col>

                <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 8 }} lg={{ span: 8 }}>
                    <Form.Item
                        label={t('order.shippingPoint')}
                        name="shippingPoint"
                        initialValue={orderItemData.shippingPoint}
                    >
                        <Input />
                    </Form.Item>
                </Col>

                <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 8 }} lg={{ span: 8 }}>
                    <Form.Item
                        label={t('order.hlItem')}
                        name="hlItem"
                        initialValue={orderItemData.hlItem}
                    >
                        <Input />
                    </Form.Item>
                </Col>

                <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 8 }} lg={{ span: 8 }}>
                    <Form.Item
                        label={t('order.poDetails')}
                        name="poDetails"
                        initialValue={orderItemData.poDetails}
                    >
                        <Input />
                    </Form.Item>
                </Col>

                <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 8 }} lg={{ span: 8 }}>
                    <Form.Item
                        label={t('order.enteredMaterial')}
                        name="enteredMaterial"
                        initialValue={orderItemData.enteredMaterial}
                    >
                        <Input />
                    </Form.Item>
                </Col>

                <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 8 }} lg={{ span: 8 }}>
                    <Form.Item
                        label={t('order.materialType')}
                        name="materialType"
                        initialValue={orderItemData.materialType}
                    >
                        <DynamicSelect location="update" type={selectOptionsTypes.materialType} onSelectChange={onSelectOptionChange} />
                    </Form.Item>
                </Col>


            </Row>
            <Divider />

            {/* {rederConditionsFields()} */}
             {rederOrderItemConditionsFields(orderItemData, "update", t)}

        </Form>
    );
}
export default UpdateOrderItemForm;